/** Валидирует значения инпутов и возвращаем для них ошибки, если валидация не пройдена */
export var validateInputs = function validateInputs(values) {
  var errors = {};
  if (!values.name) {
    errors.name = 'Укажите ваше имя';
  } else if (!/^[а-яА-Я\s]+$/.test(values.name)) {
    errors.name = 'Имя должно содержать только русские буквы';
  } else {
    errors.name = undefined;
  }
  if (!values.phone) {
    errors.phone = 'Укажите ваш телефон';
  } else if (!/\d{11}/.test(values.phone)) {
    errors.phone = 'Номер указан не полностью';
  } else {
    errors.phone = undefined;
  }
  return errors;
};